/**
 * Client's location
 * @typedef {Object} Location
 * @property {string} zipCode
 * @property {string} dma
 */

var geoLocationApi = require('src/interlock/no-ui/geolocation-api/geolocation-api.js');

function _transformResponse(data) {
    return Array.isArray(data) ? data[0] : data;
}

/**
 * Get location details by a client's IP
 * @return {Promise.<Location>}
 */
function _getLocationByClientIP() {
    var request = $.get('/api/zip/v2/fromclientip');
    
    return $.when(request).then(_transformResponse);
}

/**
 * Get location details by a client's coordinates
 * @param  {Object}    coords
 * @param  {String}    coords.latitude
 * @param  {String}    coords.longitude
 * @return {Promise.<Location>}
 */
function _getLocationByCoords(coords) {
    var request = $.get('/api/zip/v2', {
        latitude: coords.latitude,
        longitude: coords.longitude
    });

    return $.when(request).then(_transformResponse);
}

/**
 * Get location details by a client's coordinates
 * Coordinates are defined by using geolocation API
 * @return {Promise.<Location>}
 */
function _getLocationByGeoApi() {
    return geoLocationApi.getLocation().then(function(loc) {
        if(loc && loc.coords) {
            return _getLocationByCoords(loc.coords);
        } else {
            return Promise.reject('Geolocation is not found.');
        }
    });
}


module.exports = {
    getLocationByClientIP: _getLocationByClientIP,
    getLocationByCoords: _getLocationByCoords,
    getLocationByGeoApi: _getLocationByGeoApi
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/geolocation/geolocation.js
// module id = 136
// module chunks = 0 1 16 24 25